import { useTranslation } from 'react-i18next'
import type { RelationType } from '@/types'
import { useSelectionStore } from '@/stores'

const RELATION_TYPES: RelationType[] = ['1-N', '1-1', '0-1', '0-N', 'N-N']

export function RelationTypeBar() {
  const { t } = useTranslation()
  const relMode = useSelectionStore((state) => state.relMode)
  const relType = useSelectionStore((state) => state.relType)
  const relationshipSourceTableId = useSelectionStore((state) => state.relationshipSourceTableId)
  const setRelationshipType = useSelectionStore((state) => state.setRelationshipType)
  const cancelRelationshipCreation = useSelectionStore((state) => state.cancelRelationshipCreation)

  if (!relMode) return null

  return (
    <div
      className="flex flex-wrap items-center gap-2 rounded-full border px-3 py-2"
      style={{
        background: 'var(--bg-app)',
        borderColor: 'var(--border)',
      }}
    >
      <span className="text-[10px]" style={{ color: 'var(--text-muted)' }}>
        {t('relation.typeLabel')}
      </span>
      {RELATION_TYPES.map((type) => {
        const active = relType === type
        return (
          <button
            key={type}
            type="button"
            onClick={() => setRelationshipType(type)}
            className="rounded-full border px-2 py-1 text-[10px] font-bold"
            style={{
              borderColor: active ? 'var(--accent)' : 'var(--border)',
              background: active ? 'var(--accent)' : 'var(--bg-card)',
              color: active ? '#fff' : 'var(--text-muted)',
            }}
          >
            {type}
          </button>
        )
      })}
      <span className="min-w-[170px] text-[10px]" style={{ color: 'var(--accent)' }}>
        {relationshipSourceTableId ? t('relation.clickTarget') : t('relation.stepSource')}
      </span>
      <button
        type="button"
        onClick={cancelRelationshipCreation}
        className="rounded-full border px-2 py-1 text-[10px]"
        style={{
          borderColor: 'var(--border)',
          background: 'var(--bg-card)',
          color: 'var(--text-muted)',
        }}
      >
        ESC
      </button>
    </div>
  )
}
